
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-66685da8!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UndertakerEdit.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./UndertakerEdit.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-66685da8!../../node_modules/vue-loader/lib/selector?type=template&index=0!./UndertakerEdit.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/UndertakerEdit.vue
// module id = 418
// module chunks = 0